import React from 'react'
import { graphql } from 'gatsby'
import SEO from '../components/seo'
import Img from 'gatsby-image'
import styled from 'styled-components'

const PostSection = styled.div`
  margin: 2em 0;
  display: grid;
  grid-template-columns: auto 1fr;
  grid-gap: 3em;

  @media screen and (max-width: 800px) {
    grid-template-columns: 1fr;
  }

  .video-responsive::before {
    display: block;
    content: '';
    padding-top: 56.25%;
  }

  .video-responsive {
    position: relative;
    display: block;
    width: 300px;
    overflow: hidden;
  }

  .video-responsive::before {
    display: block;
    content: '';
    padding-top: 56.25%;
  }

  .video-responsive-item {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 0;
  }
`

const ImageSection = styled.div`
  max-width: 700px;
  margin: 0 auto;

  div {
    position: relative;
  padding-bottom: 59.25%; /* 16:9 */
  height: 0;
  margin-bottom:2em;
  }

  iframe {
    position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  }

`



const Title = styled.h1`
  font-size: 0.9em;
  font-weight: normal;
  text-transform: uppercase;

  @media screen and (max-width: 800px) {
    margin-bottom: 2em;
  }
`

const LadderPage = ({ data }) => {
  const collection = data.prismicBuildingALadder
  return (
    <>
      <SEO title={collection.data.title.text} 
         />
      <div>
        <PostSection>
          <div>
            <Title> {collection.data.title.text}</Title>
          </div>

          <div>
            <ImageSection>
            <div
            dangerouslySetInnerHTML={{
              __html: collection.data.content.text,
            }}
          />
               <div>
            {collection.data.gallery.map(node => (
              <ImageSection key={node.id}>
                <Img
              fluid={node.image.localFile.childImageSharp.fluid}
            />
                {/* <Img fluid={image.fluid} key={image.id} alt={image.title} /> */}
              </ImageSection>
            ))}
          </div>
            </ImageSection>
          </div>
        </PostSection>
      </div>
    </>
  )
}

export const query = graphql`
  query($id: String!) {
    prismicBuildingALadder(id: { eq: $id }) {
      id
      
      data {
        title {
          text
        }
     content {
       text
     }
     gallery {
        image {
          localFile {

          childImageSharp {
              fluid {
                ...GatsbyImageSharpFluid_withWebp
              }
            }
            }
        }
      }
      }

     
    }
  }
`

export default LadderPage
